exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._2KIO4z5zLgMqg-V1oXJlxl {\n  height: 100%;\n  position: relative;\n}\n\n._3vUziVnJzTui-o_YrBbtLu {\n  margin-left: -16px;\n}\n._2UeovWNAKv370P6Ac22j3S {\n  margin-left: -70px;\n}\n\n._2Yae7qnB31mCb4xIOqXgXi {\n  margin-left: 78px;\n}\n._1Gq7ANCOLnpMXWTjg0pX8S {\n  margin-left: 55px;\n}\n\n._21TC0f-fTyIOu0llSOVDUa {\n  margin-left: 78px;\n}\n._25HSvE5lLHZuvqXzj9nHRI {\n  margin-left: 55px;\n}\n\n._1l_rjtm68V2PiKSq6TUSxP {\n  margin-left: -75px;\n}\n\n._2Nr6sFcNM66RtBZqZqZ0gn {\n  margin-left: -75px;\n}\n\n._2BY-jqEiW_Z1p-X2lViukF {\n  margin-left: -135px;\n}", ""]);

// exports
exports.locals = {
	"bloodPressureTable": "_2KIO4z5zLgMqg-V1oXJlxl",
	"datePopover": "_3vUziVnJzTui-o_YrBbtLu",
	"datePopoverWithSelection": "_2UeovWNAKv370P6Ac22j3S",
	"sourcePopover": "_2Yae7qnB31mCb4xIOqXgXi",
	"sourcePopoverWithSelection": "_1Gq7ANCOLnpMXWTjg0pX8S",
	"categoryPopover": "_21TC0f-fTyIOu0llSOVDUa",
	"categoryPopoverWithSelection": "_25HSvE5lLHZuvqXzj9nHRI",
	"bpmPopover": "_1l_rjtm68V2PiKSq6TUSxP",
	"systolicPopover": "_2Nr6sFcNM66RtBZqZqZ0gn",
	"diastolicPopover": "_2BY-jqEiW_Z1p-X2lViukF"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":{"localIdentName":"[name]__[local]___[hash:base64:5]"}}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null,null]}!./src/legacy/containers/Tables/BloodPressureTable/BloodPressureTable.css
// module id = 9007
// module chunks = 23